import { render, staticRenderFns } from "./broken-network.vue?vue&type=template&id=979b2230&scoped=true&"
import script from "./broken-network.vue?vue&type=script&lang=js&"
export * from "./broken-network.vue?vue&type=script&lang=js&"
import style0 from "./broken-network.vue?vue&type=style&index=0&id=979b2230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979b2230",
  null
  
)

export default component.exports